import { computed } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import { queryKeys } from '../queryKeys';
import { ENTITY_LIST_QUERY_OPTIONS } from '../constants';

import { getTeamMembers } from '@/modules/Team/api/teamApi';
import { useTeamDependencies } from '@/modules/Team/composables/useTeamDependencies';

export function useTeamMembersQuery() {
  const { apiClient, accountId } = useTeamDependencies();

  return useQuery({
    queryKey: computed(() => queryKeys.team.members(accountId.value)),
    queryFn: () => getTeamMembers({
      accountId: accountId.value,
      deps: { apiClient },
    }),
    enabled: computed(() => Boolean(accountId.value)),
    ...ENTITY_LIST_QUERY_OPTIONS,
    select: (response) => response.data,
  });
}
